const normalizeText = (value = '') => `${value || ''}`.trim().toLowerCase()

export const normalizePublicBusinessSlug = (value = '') => {
  return `${value || ''}`
    .trim()
    .replace(/^https?:\/\/[^/]+/i, '')
    .replace(/^\/+/, '')
    .replace(/^w\/+/i, '')
    .replace(/^\/+/, '')
    .replace(/\/+$/, '')
}

export const normalizeGatewayPaymentName = (payment = '') => {
  const normalized = normalizeText(payment)
  if (!normalized) return ''

  if (normalized === 'webpay' || normalized === 'flow') return 'Webpay'
  if (normalized === 'mercadopago' || normalized === 'mercado pago') return 'Mercado Pago'
  if (normalized === 'klap') return 'Klap'

  return `${payment || ''}`.trim()
}

export const getGatewayPaymentKey = (payment = '') => {
  const normalized = normalizeText(payment)
  if (normalized === 'webpay' || normalized === 'flow') return 'flow'
  if (normalized === 'mercadopago' || normalized === 'mercado pago') return 'mercadopago'
  if (normalized === 'klap') return 'klap'
  return ''
}

export const isGatewayPayment = (payment = '') => !!getGatewayPaymentKey(payment)

export const isImmediateGatewayPayment = (payment = '') => {
  const key = getGatewayPaymentKey(payment)
  return key === 'flow' || key === 'mercadopago'
}

export const buildPublicPaymentBridgeUrl = ({
  root = '',
  business = '',
  ticketId = ''
} = {}) => {
  const browserOrigin = typeof window !== 'undefined' && window.location
    ? window.location.origin
    : ''
  const cleanRoot = `${browserOrigin || root || ''}`.trim().replace(/\/+$/, '')
  const base = cleanRoot.endsWith('/w') ? cleanRoot : `${cleanRoot}/w`
  const businessSlug = normalizePublicBusinessSlug(business)
  return `${base}/${businessSlug}/pago/${ticketId}`
}

export const buildPublicTicketUrl = ({
  business = '',
  ticketId = ''
} = {}) => {
  const cleanBusiness = normalizePublicBusinessSlug(business)
  const cleanTicketId = `${ticketId || ''}`.trim()
  return `/${cleanBusiness}/pedido/${cleanTicketId}`
}

export const redirectGatewayPayment = async ({
  http,
  ticket,
  business = '',
  currentUrl = ''
} = {}) => {
  const gateway = getGatewayPaymentKey(ticket && ticket.payment ? ticket.payment : '')
  if (!http || !ticket || !ticket._id || !gateway) return null

  if (gateway === 'flow') {
    const res = await http.post(`${ticket._id}/flow`)
    const data = res && res.data && res.data.data ? res.data.data : {}
    if (data.url) {
      window.location.href = `${data.url}?token=${data.token || ''}`
    }
    return data
  }

  if (gateway === 'klap') {
    const res = await http.post(`${ticket._id}/klap`)
    const data = res && res.data ? res.data : {}
    if (data.redirect_url) {
      window.location.href = data.redirect_url
    }
    return data
  }

  if (gateway === 'mercadopago') {
    const businessSlug = normalizePublicBusinessSlug(business || ticket.business || '')

    if (businessSlug) {
      const root = http && http.options ? http.options.root : ''
      const redirectUrl = buildPublicPaymentBridgeUrl({
        root,
        business: businessSlug,
        ticketId: ticket._id
      })
      window.location.href = redirectUrl
      return { init_point: redirectUrl }
    }

    const res = await http.post(`${ticket._id}/mercadopago`, {
      url: currentUrl || (typeof window !== 'undefined' ? window.location.href.split('?')[0] : '')
    })
    const data = res && res.data ? res.data : {}
    if (data.init_point) {
      window.location.href = data.init_point
    }
    return data
  }

  return null
}
